import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { SyntaxHelp } from "@/components/SyntaxHelp";

export function SyntaxHelpPage() {
  return (
    <>
      <Helmet>
        <title>Search Syntax — e621 Animation Finder</title>
        <meta
          name="description"
          content="Reference for the e621 Animation Finder tag query language: AND, OR, NOT, rating, score, date, order, artist/character/species scopes, and numeric range filters."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://gif-search.maxresdefault.zip/syntax-help" />

        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://gif-search.maxresdefault.zip/syntax-help" />
        <meta property="og:title" content="Search Syntax — e621 Animation Finder" />
        <meta
          property="og:description"
          content="Reference for the tag query language: AND, OR, NOT, rating, score, date, order, artist/character/species scopes, and numeric range filters."
        />
        <meta property="og:image" content="https://gif-search.maxresdefault.zip/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="min-h-screen bg-surface-0">
        <div className="sticky top-0 z-30 bg-surface-0/95 backdrop-blur border-b border-surface-2 px-4 py-3">
          <div className="max-w-3xl mx-auto flex items-center gap-3">
            <Link to="/" className="text-sm text-zinc-400 hover:text-white transition-colors">
              ← Home
            </Link>
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 py-8">
          <SyntaxHelp />
        </div>
      </div>
    </>
  );
}
